import { useContext } from "react";
import {
  Picker,
  PickerSection,
  PickerItem,
  Collection,
  Header,
  Text,
} from "@react-spectrum/s2";

import { AudioPlayer } from "@app/components/AudioPlayer";
import { VideoWizardContext } from "@app/views/projects/videoWizardContext";
import { Step } from "./Step";

import { style } from "@react-spectrum/s2/style" with { type: "macro" };

export const AudioStep = ({ onContinue, onBack, continueLabel }) => {
  const {
    video,
    selectedMusicTrackId,
    setSelectedMusicTrackId,
    selectedMusicTrackURL,
    groupedMusicTracks,
    updateVideo,
    customerBranding,
  } = useContext(VideoWizardContext);

  return (
    <>
      <Step
        styles={style({
          gridArea: "content",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 32,
          size: "full",
        })}
      >
        <Step.Header
          title="Select a music track"
          subtitle="Choose the track that sets the tone for your video."
        />
        <div
          className={style({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 24,
            width: "full",
            maxWidth: 800,
          })}
        >
          <Picker
            label="Music track"
            labelPosition="side"
            items={groupedMusicTracks}
            selectedKey={video.data?.musicPath ?? selectedMusicTrackId}
            onSelectionChange={(key) => {
              if (key != null) {
                setSelectedMusicTrackId(key);
                updateVideo.mutate({ musicPath: key });
              }
            }}
          >
            {(group) => (
              <PickerSection id={group.section}>
                <Header>{group.label}</Header>
                <Collection items={group.items}>
                  {(item) => (
                    <PickerItem id={item.id} textValue={item.label}>
                      <Text slot="label">{item.label}</Text>
                      <Text slot="description">{item.description}</Text>
                    </PickerItem>
                  )}
                </Collection>
              </PickerSection>
            )}
          </Picker>
          <div
            className={style({
              width: "full",
              paddingX: 16,
              paddingY: 12,
              backgroundColor: "layer-1",
              borderRadius: "default",
              boxShadow: "emphasized",
            })}
          >
            <AudioPlayer
              url={selectedMusicTrackURL.data?.presignURL}
              isAudioJobScheduled={selectedMusicTrackURL.isLoading}
              isEditorEmpty={!selectedMusicTrackURL.data?.presignURL}
            />
          </div>
        </div>
      </Step>

      <Step.Actions
        onBack={onBack}
        onContinue={onContinue}
        continueLabel={continueLabel}
        isContinueDisabled={
          !video.data?.campaigns?.length ||
          (customerBranding.isEnabled && customerBranding.isPending)
        }
      />
    </>
  );
};
